module.exports = __webpack_public_path__ + "static/media/ProximaNova-Semibold.8feb512e.woff";